import { doPost } from '#lib/network/helpers';

interface PropertyManagementCallHelpParams {
  contactPhone: string;
  queryReason: string;
}

export const contact = {
  propertyManagementCallHelp: (params: PropertyManagementCallHelpParams) =>
    doPost<void>('/dashboard/contact/property-management/help', params)
};
